import { GetRequest } from "./requestHelpers";

const NOT_SET = "NOT_SET";
const CONFIG_PATH = "FaK5SxpTXbaF";

class ConfigService {
	constructor() {
		this.config = {
			PUSHER_APP_KEY: NOT_SET,
		};
	}

	async loadConfig() {
		if (process.env.NODE_ENV === "development") {
			this.loadFromEnv();
		} else {
			await this.loadConfigFromJson();
		}

		this.validateConfig();
	}

	loadFromEnv() {
		this.config = {
			...this.config,
			PUSHER_APP_KEY: process.env.REACT_APP_PUSHER_APP_KEY,
		};
	}

	async loadConfigFromJson() {
		try {
			const response = await GetRequest(CONFIG_PATH);
			const base64Content = await response.text();
			if (base64Content) {
				try {
					const decoded = atob(base64Content.trim());
					const envConfig = JSON.parse(decoded);
					this.config = { ...this.config, ...envConfig };
				} catch (decodeError) {
					console.error("Failed to decode base64 configuration:", decodeError);
				}
			} else {
				console.warn("Empty configuration file");
			}
		} catch (error) {
			console.warn("Failed to load runtime config", error);
		}
	}

	get(key) {
		return this.config[key];
	}

	validateConfig() {
		Object.entries(this.config).forEach(([key, value]) => {
			if (value === NOT_SET || value === "") {
				console.warn(`Missing config: ${key}`);
			}
		});
	}
}

export default new ConfigService();
